const actionTypes = {
  chartsPage: {
    setSelectFilter: 'chartsPage/setSelectFilter',
    getCharts: 'chartsPage/getCharts',
    getTags: 'chartsPage/getTags',
    pageUpdate: 'chartsPage/pageUpdated',
    getCreators: 'chartsPage/getCreators',
    updateChart: 'chartsPage/updateChart',
    getTeamId: 'chartsPage/getTeamId',

    set: 'chartsPage/set',
    updateCharts: 'chartsPage/updateCharts'
  },
  packagesPage: {
    set: 'packagesPage/set',
    getTeamPackages: 'packagesPage/getTeamPackages',
    searchTeamPackages: 'packagesPage/searchTeamPackages',
    loadPackageProject: 'packagesPage/loadPackageProject'
  },
  profile: {
    set: 'profile/set'
  }
};

export default actionTypes;
